import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
  Sends a page_view event to Google Analytics (gtag.js) on every route change.
  Mirrors the original hook used by the site.
*/
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
    });
  }, [location]);
}

export default usePageTracking;
